<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>Groene Kaart</h2>

<div modal-content class="modal-body">
    <!-- AUTO -->
    <ng-container *ngIf="(car$ | async).length > 0">
        <div class="modal-title">
            <h3>Auto</h3>
        </div>

        <div class="insurance-imic" *ngFor="let purchasedProduct of car$ | async">
            <div class="insurance-imic__container">
                <div class="insurance-imic__head" (click)="auto.toggle()">
                    <div class="insurance-imic__brand">
                        {{ purchasedProduct?.product?.car?.motorVehicleMake | capitalize }}
                    </div>
                    <div class="insurance-imic__license-plate">
                        {{ purchasedProduct?.product?.car?.licensePlate | kenteken }}
                    </div>
                    <div class="insurance-imic__button">
                        <span *ngIf="!auto.visible">downloaden</span>
                        <span *ngIf="auto.visible">inklappen</span>
                    </div>
                </div>
                <ins-panel-expandable [hasBorder]="false" direction="left" #auto="panel">
                    <cyno-tabset>
                        <cyno-tab title="Auto" active="true">
                            <ins-insurance-imic-buttons
                                *ngIf="auto.visible"
                                [purchasedProduct]="purchasedProduct"
                            ></ins-insurance-imic-buttons>
                        </cyno-tab>
                        <cyno-tab title="Caravan">
                            <ins-insurance-imic-vehicle
                                *ngIf="auto.visible"
                                vehicleType="Caravan"
                                [purchasedProduct]="purchasedProduct"
                            ></ins-insurance-imic-vehicle>
                        </cyno-tab>
                        <cyno-tab title="Aanhanger">
                            <ins-insurance-imic-vehicle
                                *ngIf="auto.visible"
                                vehicleType="Trailer"
                                [purchasedProduct]="purchasedProduct"
                            ></ins-insurance-imic-vehicle>
                        </cyno-tab>
                    </cyno-tabset>
                </ins-panel-expandable>
            </div>
            <hr />
        </div>
    </ng-container>

    <!-- // AUTO -->

    <!-- BROMMER -->
    <ng-container *ngIf="(moped$ | async).length > 0">
        <div class="modal-title">
            <h3>Brommer</h3>
        </div>

        <div class="insurance-imic" *ngFor="let purchasedProduct of moped$ | async">
            <div class="insurance-imic__container">
                <div class="insurance-imic__head" (click)="brommer.toggle()">
                    <div class="insurance-imic__brand">
                        {{ purchasedProduct?.product?.moped?.motorVehicleMake | capitalize }}
                    </div>
                    <div class="insurance-imic__license-plate">
                        {{ purchasedProduct?.product?.moped?.licensePlate | kenteken }}
                    </div>
                    <div class="insurance-imic__button">
                        <span *ngIf="!brommer.visible">downloaden</span>
                        <span *ngIf="brommer.visible">inklappen</span>
                    </div>
                </div>
                <ins-panel-expandable class="insurance-imic__inner" [hasBorder]="false" direction="left" #brommer="panel">
                    <ins-insurance-imic-buttons
                        *ngIf="brommer.visible"
                        [purchasedProduct]="purchasedProduct"
                    ></ins-insurance-imic-buttons>
                </ins-panel-expandable>
            </div>
            <hr />
        </div>
    </ng-container>

    <!-- // BROMMER -->

    <!-- MOTOR -->

    <ng-container *ngIf="(motorcycle$ | async).length > 0">
        <div class="modal-title">
            <h3>Motor</h3>
        </div>

        <div class="insurance-imic" *ngFor="let purchasedProduct of motorcycle$ | async">
            <div class="insurance-imic__container">
                <div class="insurance-imic__head" (click)="motor.toggle()">
                    <div class="insurance-imic__brand">
                        {{ purchasedProduct?.product?.motorcycle?.motorVehicleMake | capitalize }}
                    </div>
                    <div class="insurance-imic__license-plate">
                        {{ purchasedProduct?.product?.motorcycle?.licensePlate | kenteken }}
                    </div>
                    <div class="insurance-imic__button">
                        <span *ngIf="!motor.visible">downloaden</span>
                        <span *ngIf="motor.visible">inklappen</span>
                    </div>
                </div>
                <ins-panel-expandable class="insurance-imic__inner" [hasBorder]="false" direction="left" #motor="panel">
                    <ins-insurance-imic-buttons
                        *ngIf="motor.visible"
                        [purchasedProduct]="purchasedProduct"
                    ></ins-insurance-imic-buttons>
                </ins-panel-expandable>
            </div>
            <hr />
        </div>
    </ng-container>

    <!-- // MOTOR -->

    <!-- CARAVAN -->

    <ng-container *ngIf="(caravan$ | async).length > 0">
        <div class="modal-title">
            <h3>Caravan</h3>
        </div>

        <div class="insurance-imic" *ngFor="let purchasedProduct of caravan$ | async">
            <div class="insurance-imic__container">
                <div class="insurance-imic__head" (click)="caravan.toggle()">
                    <div class="insurance-imic__brand">
                        {{ purchasedProduct?.product?.caravan?.caravanBrand | capitalize }}
                    </div>
                    <div class="insurance-imic__license-plate">
                        {{ purchasedProduct?.product?.caravan?.licensePlate | kenteken }}
                    </div>
                    <div class="insurance-imic__button">
                        <span *ngIf="!caravan.visible">downloaden</span>
                        <span *ngIf="caravan.visible">inklappen</span>
                    </div>
                </div>
                <ins-panel-expandable class="insurance-imic__inner" [hasBorder]="false" direction="left" #caravan="panel">
                    <ins-insurance-imic-caravan
                        *ngIf="caravan.visible"
                        [purchasedProduct]="purchasedProduct"
                    ></ins-insurance-imic-caravan>
                </ins-panel-expandable>
            </div>
            <hr />
        </div>
    </ng-container>
</div>

<!-- // CARAVAN -->
